module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7fcbbbf879415d8bd7703b7560c08c28.png";